import { createContext, useState } from "react";

export const TenantContext = createContext();

export const TenantContextProvider = ({ children }) => {
  const [tenantData, setTenantData] = useState(null);
  const [tenantLogo, setTenantLogo] = useState(null);
  const [tenantLogoKey, setTenantLogoKey] = useState(0);

  return (
    <TenantContext.Provider
      value={{
        tenantData,
        setTenantData,
        tenantLogo,
        setTenantLogo,
        tenantLogoKey,
        setTenantLogoKey,
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};
